import { ChangeDetectorRef, OnDestroy, OnInit, Pipe, PipeTransform } from '@angular/core';
import { DateTimezoneService } from '@services/date-timezone.service';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Pipe({
  name: 'customUserDateTime',
  pure: false,
})
export class CustomUserDateTimePipe implements PipeTransform, OnInit, OnDestroy {
  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(private dateTimezoneService: DateTimezoneService, private cd: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.dateTimezoneService.timezone.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.cd.detectChanges();
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  public transform(value: any, format: string = 'MM/DD/YYYY h:mm A'): string {
    if (!value) {
      return '';
    }

    return this.dateTimezoneService.formatInUserTZ(value, format);
  }
}
